import * as React from "react";
import { WithStyles, withStyles, Theme, createStyles, List, ListSubheader } from "@material-ui/core";
import VideoListItem from "./VideoListItem";
import { withRouter, RouteComponentProps } from "react-router-dom";

interface VideoListProps extends WithStyles<typeof styles>, RouteComponentProps<any> {
  videoTitles: string[];
  path: string;
}

interface VideoListState {}

class VideoList extends React.PureComponent<VideoListProps, VideoListState> {
  render() {
    const { classes, videoTitles, path } = this.props;

    return (
      <div className={classes.root}>
        <List className={classes.list} subheader={<ListSubheader>Help Topics</ListSubheader>}>
          {videoTitles.map(title => (
            <VideoListItem key={title} path={path} title={title} />
          ))}
        </List>
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      overflow: "auto"
    },
    list: {
      paddingBottom: "2rem"
    },
    link: {
      textDecoration: "none",
      color: theme.palette.text.primary
    }
  });

export default withStyles(styles)(withRouter(VideoList));
